<template>
    <div class="card min-height">
        <div class="card-body">
            <div class="row flex-1">
                <div class="col-xl-3">
                    <h3 class="mt-0 mb-3">Edit Account</h3>
                    <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                        <a :class="profileInfo ? 'active' : null" class="nav-link" href="#" role="tab" @click="setProfileInfo(true)">
                            Profile Info
                        </a>
                        <a :class="changePassword ? 'active' : null" class="nav-link" href="#" role="tab" @click="setChangePassword(true)">
                            Change Password
                        </a>
                    </div>
                </div>
                <div class="col-xl-9">
                    <div class="row h-100">
                        <div v-if="profileInfo" class="col-xl-10">
                            <profile-info :user="user"></profile-info>
                        </div>
                        <div v-if="changePassword" class="col-xl-10">
                            <change-password></change-password>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProfileInfo from './ProfileInfo'
import ChangePassword from './ChangePassword'
export default {
    components: {
        ChangePassword,
        ProfileInfo
    },
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            profileInfo: true,
            changePassword: false
        }
    },
    methods: {
        setProfileInfo(value) {
            this.changePassword = false
            this.profileInfo = value
        },
        setChangePassword(value) {
            this.profileInfo = false
            this.changePassword = value
        }
    }
}
</script>

<style lang="scss" scoped>
.min-height {
    min-height: 600px;
}
</style>
